<template>
  <div class="powerTc" >
    <div class="title">
      <span style="float: left;padding-left: 35px;padding-top: 10px">
        能源管理
      </span>
      <span>
        <i class="el-icon-error" style="padding-right:21px;padding-top:15px;float: right;cursor:pointer;" @click="closeTc"></i>
      </span>
    </div>
    <div class="use-sum">
      用电统计
    </div>
    <div class="use-power-month">
      <div class="text-style">
        <span>本期用电</span>
        <span style="padding-left:67px;font-size: 18px;font-family: Alternate;color: #6CBCFD;line-height: 21px;letter-spacing: 2px;">{{ (wholeDegreeTotal/10000).toFixed(2) }}</span>
        <span style="padding-left: 4px">万度</span>
      </div>
      <div style="position:absolute;top:196px;left:35px">
        <div class="rectangle" style="height:9px;width:127px;background-color:rgba(108, 188, 253, 1);"></div>
        <div class="rectangle" style="height:9px;width:127px;background-color:rgba(1, 43, 85, 1);"></div>
      </div>
    </div>
    <div class="use-power-month" >
      <div class="text-style" style="top:268px">
        <span style="color: rgba(0, 181, 127, 0.8)">上期用电</span>
        <span style="padding-left:67px;font-size: 18px;font-family: Alternate;color: rgba(0, 181, 127, 1);line-height: 21px;letter-spacing: 2px;">{{ (lastPeriodWholeDegreeTotal/10000).toFixed(2) }}</span>
        <span style="padding-left: 4px;color: rgba(0, 181, 127, 0.8)">万度</span>
      </div>
      <div style="position:absolute;top:312px;left:35px">
        <div class="rectangle" style="height:9px;width:127px;background-color:rgba(0, 181, 127, 1);"></div>
        <div class="rectangle" style="height:9px;width:127px;background-color:rgba(2, 74, 51, 1);"></div>
      </div>
    </div>
    <div class="use-sum" style="position:absolute;top:394px">
      用电占比
    </div>
    <div class="color-table-show" style="position:absolute;left:37px;top:462px">
      <!--      <div style="margin-top: 25px;" v-for="(item , index) in allarr">-->
      <!--        <div class="square" :style='{background:colorList[index][0]}'></div>-->
      <!--        <div class="text1">{{item.monitorSiteName}}</div>-->
      <!--        <div class="text2">25%</div>-->
      <!--        <div class="text3">2234</div>-->
      <!--      </div>-->
      <div style="margin-top: 15px;" v-for="(item , index) in allarr" v-show="way=='sta'">
        <div class="square" :style='{background:colorList[index]}'></div>
        <div class="text1" >{{ item.monitorSiteName }}</div>
        <div class="text2">{{ item.proportion }}%</div>
        <div class="text3">{{ item.monitorSiteDegree }}</div>
      </div>
      <div style="margin-top: 15px;" v-for="(item , index) in allarr" v-show="way=='dep'">
        <div class="square" :style='{background:colorList[index]}'></div>
        <div class="text1" >{{ item.deptName }}</div>
        <div class="text2">{{ item.proportion }}%</div>
        <div class="text3">{{ item.deptEnergy }}</div>
      </div>
      <!--      <div style="margin-top: 25px;">-->
      <!--      <div class="square" style="background: rgba(0, 181, 127, 0.5);border: 1px solid #00B57F;"></div>-->
      <!--      <div class="text1">监测点名称最多十个字…</div>-->
      <!--      <div class="text2">10%</div>-->
      <!--      <div class="text3">2234</div>-->
      <!--    </div>-->
      <!--      <div style="margin-top: 25px;">-->
      <!--      <div class="square" style="background: rgba(250, 219, 20, 0.5);border: 1px solid #FADB14;"></div>-->
      <!--      <div class="text1">监测点名称最多十个字…</div>-->
      <!--      <div class="text2">5%</div>-->
      <!--      <div class="text3">2234</div>-->
      <!--    </div>-->
      <!--      <div style="margin-top: 25px;">-->
      <!--      <div class="square" style="background: rgba(255, 169, 64, 0.5);border: 1px solid #FFA940;"></div>-->
      <!--      <div class="text1">监测点名称最多十个字…</div>-->
      <!--      <div class="text2">3%</div>-->
      <!--      <div class="text3">2234</div>-->
      <!--    </div>-->
      <!--      <div style="margin-top: 25px;">-->
      <!--      <div class="square" style="background:rgba(214, 30, 30, 0.5);border: 1px solid #D61E1E;"></div>-->
      <!--      <div class="text1" >用电总量…</div>-->
      <!--      <div class="text2" >100%</div>-->
      <!--      <div class="text3">123400</div>-->
      <!--    </div>-->
    </div>

    <div class="tu-biao">
      <div style="height: 32px;position:absolute; left:365px;top:83px;width: 420px;">
        <div class="btn-left-list">
          <span class="btn-item" @click="changeWeek2('week')">
            <div >日</div>
            <div class="blue-blank" :class="type2=='week'?'':'disnone'"></div>
          </span>
          <span class="btn-item" @click="changeWeek2('month')">
            <div>月</div>
            <div class="blue-blank" :class="type2=='month'?'':'disnone'"></div>
          </span>
        </div>
        <div class="time-blank" style="z-index: 100">
          <el-date-picker
            v-model="dayTime"
            value-format="yyyy-MM-dd"
            type="date"
            v-if="type2=='week'"
            placeholder="选择日期">
          </el-date-picker>
          <el-date-picker
            v-if="type2=='month'"
            v-model="monthTime"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择月份"
          ></el-date-picker>
        </div>
        <!--        <div style="display: inline-block;width: 256px;height: 32px;border: 1px solid #0B47A5;position:relative;left:55px;padding-left: 12px;padding-top: 6px;font-size: 14px;font-family: PingFang;color: #6CBCFD;line-height: 22px;">-->
        <!--          2015-10-->
        <!--          <i class="el-icon-date" style="padding-left: 160px"></i>-->
        <!--        </div>-->
      </div>
    </div>

    <div class="tu-biao" style="position:absolute;top:420px;right:0px;">
      <div class="btn-list">
          <span class="btn-item" @click="changeWeek('week')">
            <div >周</div>
            <div class="blue-blank" :class="type=='week'?'':'disnone'"></div>
          </span>
        <span class="btn-item" @click="changeWeek('month')">
            <div>月</div>
            <div class="blue-blank" :class="type=='month'?'':'disnone'"></div>
          </span>
      </div>
    </div>
    <div class="tu-biao" style="position:absolute;top:420px;right:400px;">
      <div class="btn-list">
           <span class="btn-bigitem" @click="changeWay('sta')">
            <div>按监测点</div>
            <div class="blue-blank big-blue" :class="way=='sta'?'':'disnone'"></div>
          </span>
          <span class="btn-bigitem" @click="changeWay('dep')">
            <div >按单位</div>
            <div class="blue-blank big-blue" :class="way=='dep'?'':'disnone'"></div>
          </span>

      </div>
    </div>
    <!--折线图-->
    <div></div>
    <!--饼状图-->
    <div></div>
    <!--测试-->
    <div style="position:absolute;top:120px;left:321px;right:25px;">
      <div class="zhe-xian-tu" id="zhe-xian" style="width: 461px;height: 300px"></div>
    </div>
    <div style="position:absolute;top:440px;left:400px;right:86px;">
      <div class="bing-tu" id="bing" style="width: 400px;height: 300px;padding-left: 100px"></div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
import Axios from "@/utils/Axios";
import Vue from "vue";
import {factors} from "@turf/turf";
import qs from "qs";
export default {
  name: "leftPage",
  data() {
    return {
      showTc:false,
      dayTime:"",
      monthTime:"",
      type:'week',
      type2:'week',
      way:'sta',
      lastPeriodWholeDegreeTotal:'',
      wholeDegreeTotal:'',
      allarr:[],
      colorList:['rgba(11, 71, 165, 0.5)','rgba(30, 197, 214, 0.5)','rgba(0, 181, 127, 0.5)','rgba(250, 219, 20, 0.5)','rgba(255, 169, 64, 0.5)','rgba(214, 30, 30, 0.5)']
    };
  },
  methods: {
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date
      var monthTime= year + "-" + month
      this.dayTime = time;
      this.monthTime = monthTime;
    },
    getdaydata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/bigScreen/deptHourEnergyTrendTotal";
      param.data={
        "localDate": this.dayTime
      }
      Axios.ajax(param).then((res)=>{
        if(res.data){

          this.wholeDegreeTotal=res.data.energyTotal
          this.lastPeriodWholeDegreeTotal=res.data.lastPeriodEnergyTotal
          this.myEcharts(res.data.energyTrends)
        }

      })
    },
    getmonthdata(){
      let that = this;
      let param = {};
      param.method="post";
      param.url="/bigScreen/deptDayEnergyTrendTotal";
      param.data={
        yearMonth: this.monthTime
      }
      Axios.ajax(param).then((res)=>{
        if(res.data){
          console.log(res)
          this.wholeDegreeTotal=res.data.energyTotal
          this.lastPeriodWholeDegreeTotal=res.data.lastPeriodEnergyTotal
          this.myEcharts(res.data.energyTrends)
        }

      })
    },

    changeWeek(data){
      this.type=data
      if(data=='week'){

        this.getpowerpie('7')
      }else{
        this.getpowerpie('30')

      }
    },
    changeWay(data){
      let that=this
      this.way=data

      if(data=='sta'){
        if(that.type='week'){
          this.getpowerpie('7')
        }else{
          this.getpowerpie('30')
        }

      }else{
        if(that.type='week'){
          this.getpowerpie2('7')
        }else{
          this.getpowerpie2('30')
        }

      }
    },
    changeWeek2(data){
      this.type2=data
      if(this.type2=='week'){
        this.getdaydata()
      }else{
        this.getmonthdata()
      }
    },
    closeTc(){
      Bus.$emit('colsetc',false )
    },
    myEcharts(data) {
      let xdata=[]
      let ydata=[]
      let lastydata=[]
      for(let i=0;i<data.length;i++){
        xdata.push(data[i].dataTime)
        ydata.push(data[i].energy)
        lastydata.push(data[i].lastPeriodEnergy)
      }
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById('zhe-xian'));

      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          /*改变xy轴颜色*/
          axisLine: {
            lineStyle: {
              color: 'rgba(108, 188, 253, 0.45)', //这里是为了突出显示加上的
            }
          },
          data: xdata
        },
        yAxis: {
          splitLine: {show: false},
          type: 'value',
          /*改变xy轴颜色*/
          axisLine: {
            lineStyle: {
              color: 'rgba(108, 188, 253, 0.45)', //这里是为了突出显示加上的
            }
          },

        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        series: [
          {
            name: '本期',
            type: 'line',
            data: ydata,
            lineStyle:{
              normal:{
                color:'rgba(108, 188, 253, 1)',
              }
            },
            itemStyle:{
              normal:{
                color:'rgba(108, 188, 253, 1)',
              }
            },
            areaStyle:{ // 这里设置区域样式
              normal:{
                color:'rgba(108, 188, 253, 0.6)',
                //这里使用默认配置
              }
            }
          },
          {
            name: '上期',
            type: 'line',
            data: lastydata,
            lineStyle:{
              normal:{
                color:'rgba(0, 181, 127, 1) ',
              }
            },
            itemStyle:{
              normal:{
                color:'rgba(0, 181, 127, 1) ',
              }
            },
            areaStyle:{ // 这里设置区域样式
              normal:{
                color:'rgba(0, 181, 127, 0.6) ',
                //这里使用默认配置
              }
            }
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    // myEcharts2() {
    //   // 基于准备好的dom，初始化echarts实例
    //   var myChart2 = this.$echarts.init(document.getElementById('bing'));
    //
    //   // 指定图表的配置项和数据
    //   var colorArr=["#218de0", "#01cbb3", "#85e647", "#5d5cda", "#05c5b0", "#c29927"];
    //   var colorAlpha=['rgba(60,170,211,0.05)','rgba(1,203,179,0.05)','rgba(133,230,71,0.05)','rgba(93,92,218,0.05)','rgba(5,197,176,0.05)','rgba(194,153,39,0.05)']
    //   var option = {
    //     grid: {
    //       left: -100,
    //       top: 50,
    //       bottom: 10,
    //       right: 10,
    //       containLabel: true
    //     },
    //     tooltip: {
    //       trigger: 'item',
    //       formatter: "{b} : {c} ({d}%)"
    //     },
    //     legend: {
    //       show:false
    //     },
    //
    //     polar: {},
    //     angleAxis: {
    //       interval: 1,
    //       type: 'category',
    //       data: [],
    //       z: 10,
    //       axisLine: {
    //         show: false,
    //         lineStyle: {
    //           color: "#0B4A6B",
    //           width: 1,
    //           type: "solid"
    //         },
    //       },
    //       axisLabel: {
    //         interval: 0,
    //         show: true,
    //         color: "#0B4A6B",
    //         margin: 8,
    //         fontSize: 16
    //       },
    //     },
    //     radiusAxis: {
    //       min: 40,
    //       max: 200,
    //       interval: 20,
    //       axisLine: {
    //         show: false,
    //         lineStyle: {
    //           color: "#0B3E5E",
    //           width: 1,
    //           type: "solid"
    //         },
    //       },
    //       axisLabel: {
    //         formatter: '{value} %',
    //         show: false,
    //         padding: [0, 0, 20, 0],
    //         color: "#0B3E5E",
    //         fontSize: 16
    //       },
    //       splitLine: {
    //         lineStyle: {
    //           color: "#07385e",
    //           width: 2,
    //           type: "dashed"
    //         }
    //       }
    //     },
    //     calculable: true,
    //     series: [ {
    //       stack: 'a',
    //       type: 'pie',
    //       radius: '80%',
    //       roseType: 'radius',
    //       zlevel:10,
    //       startAngle: 100,
    //       label: {
    //         normal: {
    //           show:false,
    //           formatter: [ '{b|{b}}','{d|{d}%}'].join('\n'),
    //           rich: {
    //             b: {
    //               color: '#3bd2fe',
    //               fontSize: 14,
    //               lineHeight: 20
    //             },
    //             d: {
    //               color: '#d0fffc',
    //               fontSize: 14,
    //               height: 20
    //             },
    //           },
    //         }
    //       },
    //       labelLine: {
    //         normal: {
    //           show: false,
    //           length: 10,
    //           length2: 45,
    //           lineStyle: {
    //             color: '#0096b1'
    //
    //           }
    //         },
    //         emphasis: {
    //           show: false
    //         }
    //       },
    //       data: [{
    //         value: 63,
    //         name: '容量小设备老旧',
    //         itemStyle: {
    //           borderColor: colorArr[0],
    //           borderWidth:2,
    //           shadowBlur: 20,
    //           shadowColor: "#41a8f8",
    //           shadowOffsetx: 25,
    //           shadowOffsety: 20,
    //           color:colorAlpha[0]
    //         }
    //       },
    //         {
    //           value: 27,
    //           name: '季节性企业用电',
    //           itemStyle: {
    //             borderColor: colorArr[1],
    //             borderWidth:2,
    //             shadowBlur: 20,
    //             shadowColor: colorArr[1],
    //             shadowOffsetx: 25,
    //             shadowOffsety: 20,
    //             color:colorAlpha[1]
    //           }
    //         },
    //         {
    //           value: 7,
    //           name: '企业用电高峰',
    //           itemStyle: {
    //             borderColor: colorArr[2],
    //             borderWidth:2,
    //             shadowBlur: 20,
    //             shadowColor: colorArr[2],
    //             shadowOffsetx: 25,
    //             shadowOffsety: 20,
    //             color:colorAlpha[2]
    //           }
    //         },
    //         {
    //           value: 13,
    //           name: '节假日',
    //           itemStyle: {
    //             borderColor: colorArr[3],
    //             borderWidth:2,
    //             shadowBlur: 20,
    //             shadowColor: colorArr[3],
    //             shadowOffsetx: 25,
    //             shadowOffsety: 20,
    //             color:colorAlpha[3]
    //           }
    //         },
    //         {
    //           value: 10,
    //           name: '临时用电',
    //           itemStyle: {
    //             borderColor: colorArr[4],
    //             borderWidth:2,
    //             shadowBlur: 20,
    //             shadowColor: colorArr[4],
    //             shadowOffsetx: 25,
    //             shadowOffsety: 20,
    //             color:colorAlpha[4]
    //           }
    //         },
    //         {
    //           value: 6,
    //           name: '三相用电不平衡',
    //           itemStyle: {
    //             borderColor: colorArr[5],
    //             borderWidth:2,
    //             shadowBlur: 20,
    //             shadowColor: colorArr[5],
    //             shadowOffsetx: 25,
    //             shadowOffsety: 20,
    //             color:colorAlpha[5]
    //           }
    //         }
    //       ]
    //     }, ]
    //   }
    //
    //
    //   // 使用刚指定的配置项和数据显示图表。
    //   myChart2.setOption(option);
    // },
    getpowerpie(type){
      let that = this;

      let param = {};
      param.method="post";
      param.url="/bigScreen/monitorEnergyProportion";
      param.data=qs.stringify({
        day:type
        // day:"3000"
      })
      Axios.ajax(param).then((res)=>{
        if(res.data){

          this.setPowerchart(res.data.monitorSiteProportions)
        }

      })
    },
    getpowerpie2(type){
      let that = this;

      let param = {};
      param.method="post";
      param.url="/portal/deptEnergyProportion";
      param.data=qs.stringify({
        day:type
        // day:"3000"
      })
      Axios.ajax(param).then((res)=>{
        if(res.data){
          this.setPowerchart2(res.data)
        }

      })
    },
    setPowerchart(data){
      let arr=data
      this.allarr=arr
      let myChart =this.$echarts.init(document.getElementById('bing'));
      var colorArr=["#218de0", "#01cbb3", "#85e647", "#5d5cda", "#05c5b0", "#c29927", "#c20027",'rgba(122,50,200)','rgba(111,100,155)','rgba(244,189,50)'];
      var colorAlpha=['rgba(60,170,211,0.05)','rgba(1,203,179,0.05)','rgba(133,230,71,0.05)','rgba(93,92,218,0.05)','rgba(5,197,176,0.05)','rgba(194,153,39,0.05)','rgba(194,20,155,0.05)','rgba(122,50,200,0.05)','rgba(111,100,155,0.05)','rgba(244,189,50,0.05)']
      let seriesdata=[]
      for(let i=0;i<arr.length;i++){
        seriesdata.push({
          value: arr[i].monitorSiteDegree,
          name: arr[i].monitorSiteName,
          itemStyle: {
            borderColor: colorArr[i],
            borderWidth:2,
            shadowBlur: 20,
            shadowColor:  colorArr[i],
            shadowOffsetx: 25,
            shadowOffsety: 20,
            color:colorAlpha[i]
          }
        })
      }
      var option = {
        grid: {
          left: 100,
          top: 50,
          bottom: 10,
          right: 100,
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          show:false
        },

        polar: {},
        angleAxis: {
          interval: 1,
          type: 'category',
          data: [],
          z: 10,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0B4A6B",
              width: 1,
              type: "solid"
            },
          },
          axisLabel: {
            interval: 0,
            show: false,
            color: "#0B4A6B",
            margin: 8,
            fontSize: 16
          },
        },
        radiusAxis: {
          min: 40,
          max: 200,
          interval: 20,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0B3E5E",
              width: 1,
              type: "solid"
            },
          },
          axisLabel: {
            formatter: '{value} %',
            show: false,
            padding: [0, 0, 20, 0],
            color: "#0B3E5E",
            fontSize: 16
          },
          splitLine: {
            lineStyle: {
              color: "#07385e",
              width: 2,
              type: "dashed"
            }
          }
        },
        calculable: true,
        series: [
          {

            type: 'pie',
            radius: '80%',
            // roseType: 'radius',
            zlevel:10,
            startAngle: 100,
            label: {
              normal: {
                show:false,
                formatter: [ '{b|{b}}','{d|{d}%}'].join('\n'),
                rich: {
                  b: {
                    color: '#3bd2fe',
                    fontSize: 14,
                    lineHeight: 20
                  },
                  d: {
                    color: '#d0fffc',
                    fontSize: 14,
                    height: 20
                  },
                },
              }
            },
            labelLine: {
              normal: {
                show: false,
                // length: 2,
                // length2: 2,
                lineStyle: {
                  color: '#0096b1'

                }
              },
              emphasis: {
                show: false
              }
            },
            data:seriesdata
            //   [{
            //   value: 63,
            //   name: '容量小设备老旧',
            //   itemStyle: {
            //     borderColor: colorArr[0],
            //     borderWidth:2,
            //     shadowBlur: 20,
            //     shadowColor: "#41a8f8",
            //     shadowOffsetx: 25,
            //     shadowOffsety: 20,
            //     color:colorAlpha[0]
            //   }
            // },
            //   {
            //     value: 27,
            //     name: '季节性企业用电',
            //     itemStyle: {
            //       borderColor: colorArr[1],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[1],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[1]
            //     }
            //   },
            //   {
            //     value: 7,
            //     name: '企业用电高峰',
            //     itemStyle: {
            //       borderColor: colorArr[2],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[2],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[2]
            //     }
            //   },
            //   {
            //     value: 13,
            //     name: '节假日',
            //     itemStyle: {
            //       borderColor: colorArr[3],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[3],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[3]
            //     }
            //   },
            //   {
            //     value: 10,
            //     name: '临时用电',
            //     itemStyle: {
            //       borderColor: colorArr[4],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[4],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[4]
            //     }
            //   },
            //   {
            //     value: 6,
            //     name: '三相用电不平衡',
            //     itemStyle: {
            //       borderColor: colorArr[5],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[5],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[5]
            //     }
            //   }
            // ]
          }, ]
      }
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
    setPowerchart2(data){
      let arr=data
      this.allarr=arr
      let myChart =this.$echarts.init(document.getElementById('bing'));
      var colorArr=["#218de0", "#01cbb3", "#85e647", "#5d5cda", "#05c5b0", "#c29927", "#c20027",'rgba(122,50,200)','rgba(111,100,155)','rgba(244,189,50)'];
      var colorAlpha=['rgba(60,170,211,0.05)','rgba(1,203,179,0.05)','rgba(133,230,71,0.05)','rgba(93,92,218,0.05)','rgba(5,197,176,0.05)','rgba(194,153,39,0.05)','rgba(194,20,155,0.05)','rgba(122,50,200,0.05)','rgba(111,100,155,0.05)','rgba(244,189,50,0.05)']
      let seriesdata=[]
      for(let i=0;i<arr.length;i++){
        seriesdata.push({
          value: arr[i].deptEnergy,
          name: arr[i].deptName,
          itemStyle: {
            borderColor: colorArr[i],
            borderWidth:2,
            shadowBlur: 20,
            shadowColor:  colorArr[i],
            shadowOffsetx: 25,
            shadowOffsety: 20,
            color:colorAlpha[i]
          }
        })
      }
      var option = {
        grid: {
          left: 100,
          top: 50,
          bottom: 10,
          right: 100,
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          show:false
        },

        polar: {},
        angleAxis: {
          interval: 1,
          type: 'category',
          data: [],
          z: 10,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0B4A6B",
              width: 1,
              type: "solid"
            },
          },
          axisLabel: {
            interval: 0,
            show: false,
            color: "#0B4A6B",
            margin: 8,
            fontSize: 16
          },
        },
        radiusAxis: {
          min: 40,
          max: 200,
          interval: 20,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#0B3E5E",
              width: 1,
              type: "solid"
            },
          },
          axisLabel: {
            formatter: '{value} %',
            show: false,
            padding: [0, 0, 20, 0],
            color: "#0B3E5E",
            fontSize: 16
          },
          splitLine: {
            lineStyle: {
              color: "#07385e",
              width: 2,
              type: "dashed"
            }
          }
        },
        calculable: true,
        series: [
          {

            type: 'pie',
            radius: '80%',
            // roseType: 'radius',
            zlevel:10,
            startAngle: 100,
            label: {
              normal: {
                show:false,
                formatter: [ '{b|{b}}','{d|{d}%}'].join('\n'),
                rich: {
                  b: {
                    color: '#3bd2fe',
                    fontSize: 14,
                    lineHeight: 20
                  },
                  d: {
                    color: '#d0fffc',
                    fontSize: 14,
                    height: 20
                  },
                },
              }
            },
            labelLine: {
              normal: {
                show: false,
                // length: 2,
                // length2: 2,
                lineStyle: {
                  color: '#0096b1'

                }
              },
              emphasis: {
                show: false
              }
            },
            data:seriesdata
            //   [{
            //   value: 63,
            //   name: '容量小设备老旧',
            //   itemStyle: {
            //     borderColor: colorArr[0],
            //     borderWidth:2,
            //     shadowBlur: 20,
            //     shadowColor: "#41a8f8",
            //     shadowOffsetx: 25,
            //     shadowOffsety: 20,
            //     color:colorAlpha[0]
            //   }
            // },
            //   {
            //     value: 27,
            //     name: '季节性企业用电',
            //     itemStyle: {
            //       borderColor: colorArr[1],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[1],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[1]
            //     }
            //   },
            //   {
            //     value: 7,
            //     name: '企业用电高峰',
            //     itemStyle: {
            //       borderColor: colorArr[2],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[2],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[2]
            //     }
            //   },
            //   {
            //     value: 13,
            //     name: '节假日',
            //     itemStyle: {
            //       borderColor: colorArr[3],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[3],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[3]
            //     }
            //   },
            //   {
            //     value: 10,
            //     name: '临时用电',
            //     itemStyle: {
            //       borderColor: colorArr[4],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[4],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[4]
            //     }
            //   },
            //   {
            //     value: 6,
            //     name: '三相用电不平衡',
            //     itemStyle: {
            //       borderColor: colorArr[5],
            //       borderWidth:2,
            //       shadowBlur: 20,
            //       shadowColor: colorArr[5],
            //       shadowOffsetx: 25,
            //       shadowOffsety: 20,
            //       color:colorAlpha[5]
            //     }
            //   }
            // ]
          }, ]
      }
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
  },
  mounted() {
    this.getnowtime();

    // this.getdaydata();

    this.getpowerpie('7');
  },
  watch:{
    dayTime(){

      if(this.type2=='week'){
        this.getdaydata()
      }else{
        this.getmonthdata()
      }
    },
    monthTime(){

      if(this.type2=='week'){
        this.getdaydata()
      }else{
        this.getmonthdata()
      }
    },
  },
  components: {

  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.powerTc{
  width: 100%;
  height: 100%;
  background-color: #0C213F;
}
//.left{
//  width: 428px;
//  height: 419px;
//  border: 1px solid #0B47A5;
//  //position: relative;
//  //left:72px;
//  //top: 270px;
//}
.title{
  height: 45px;
  width: 100%;
  background-color: rgba(61, 130, 234, 0.4);
  font-size: 16px;
  font-family: PingFang;
  color: #6CBCFD;
  line-height: 24px;
  letter-spacing: 2px;
}
.use-sum{
  width: 268px;
  height: 45px;
  font-size: 14px;
  font-family: PingFang;
  color: rgba(255, 169, 64, 0.8);
  line-height: 20px;
  letter-spacing: 2px;
  padding-top: 14px;
  padding-left:34px;
  position: relative;
  top:22px;
}
.text-style{
  font-size: 14px;
  font-family: PingFang;
  color: rgba(108, 188, 253, 0.8);
  line-height: 20px;
  letter-spacing: 2px;
  position: absolute;
  top:152px;
  left:34px;
}
.rectangle{
  display: inline-block;
}
.square{
  display: inline-block;
  width: 14px;
  height: 14px;
  background: rgba(11, 71, 165, 0.5);
  border: 1px solid #0B47A5;
}
.text1{
  padding-left:14px;
  display: inline-block;
  font-size: 12px;
  font-family: PingFang;
  color: #6CBCFD;
  line-height: 17px;
  letter-spacing: 1px;
}
.text2{
  position: absolute;
  left:268px;
  display: inline-block;
  font-size: 16px;
  font-family: Alternate;
  font-weight: bold;
  color: #6CBCFD;
  line-height: 19px;
  letter-spacing: 2px;
}
.text3{
  position: absolute;
  left:360px;
  display: inline-block;
  font-size: 16px;
  font-family: Alternate;
  color: #6CBCFD;
  line-height: 19px;
  letter-spacing: 2px;
}
.warm-type{
  display: inline-block;
  vertical-align: top;
  width: 370px;
  height: 160px;
  margin-left: 23px;
}
.warm-list{
  display: inline-block;
  vertical-align: top;
  width: 150px;
  height: 160px;
  margin-left: 23px;
}
.btn-list{
  float: right;
  margin-right: 37px;
  color: #6CBCFD;
  font-size: 14px;
  text-align: center;
  .btn-item{
    width: 36px;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
  }
  .disnone{
    display: none;
  }
  .blue-blank{
    width: 36px;
    height: 3px;
    background-color: #6CBCFD;
    position: relative;
    top: 2px;
  }
  .big-blue{
    width: 80px;
    height: 3px;
  }
  .btn-bigitem{
    width: 80px;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
  }
}
.btn-left-list{

  color: #6CBCFD;
  font-size: 14px;
  width: 100px;
  display: inline-block;
  .btn-item{
    width: 36px;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
  }
  .disnone{
    display: none;
  }
  .blue-blank{

    width: 36px;
    height: 3px;
    background-color: #6CBCFD;
    position: relative;
    top: 2px;

  }
}
.time-blank{
  float: right;
}
</style>
<style>
#app .login-wrap .time-blank .el-date-editor.el-input__inner, #app .time-blank .el-date-editor > .el-input__inner{
  background-color: #0C213F;
  color: #6CBCFD;
  border: 1px solid #0B47A5;
}
#app .time-blank .el-input__prefix, .el-input__suffix{
  color: #6CBCFD;

}
</style>

